<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">ปิดปรับปรุงระบบชั่วคราว</span>
      </div>
    </template>
    <template v-else>
      <v-container>
        <v-card>
          <v-toolbar
              color="primary">
            <v-card-title class="headline mb-1">
              <span style="color:white"> งานประชุม</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-list-item>
              <v-spacer></v-spacer>
              <v-text-field
                  label="ค้นหา"
                  v-model="search"
              ></v-text-field>
            </v-list-item>
            <v-list-item class="justify-center">
              <v-radio-group row v-model="MeetFilter" @change="ChangeTypeMeeting">
                <v-radio label="ทั้งหมด" value="0"></v-radio>
                <v-radio label="งานที่กำลังดำเนินการ" value="1"></v-radio>
                <v-radio label="งานที่รอดำเนินการ" value="2"></v-radio>
                <v-radio label="งานที่เคยเข้าร่วม" value="3"></v-radio>
              </v-radio-group>
            </v-list-item>
            <v-data-table
                :headers="HeaderMeeting"
                :items="MeetingDataDump"
                :search="search"
            >
              <template v-slot:item.Topic_Custom="{item}">
                <div v-html="item.Topic_Custom"></div>
              </template>
              <template v-slot:item.action="{item}">
                <div v-if="MeetFilter != '3'">
                  <v-btn text color="#00C853" @click="OpenLingMeeting(item)" class="text--darken-4">
                    สมัครเข้าร่วมประชุม
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn text color="yellow" @click="OpenDetailMeeting(item)" class="text--darken-4">
                    รายละเอียด
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
      <template>
        <v-dialog
            v-model="dialogEdit"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-btn
                  icon
                  dark
                  @click="dialogEdit = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>แก้ไขข้อมูลการประชุม</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="EditMeetingExec"
                >
                  แก้ไข
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list
                three-line
                subheader
            >
              <v-subheader>รายละเอียดข้อมูลการจัดประชุม</v-subheader>
              <v-list-item>
                <v-container>
                  <v-tabs
                      v-model="tab"
                      background-color="transparent"
                      grow
                  >
                    <v-tab
                        key="DataMeeting"
                    >
                      ข้อมูลจัดประชุม
                    </v-tab>
                    <v-tab
                        key="DataJoinMeeting"
                    >
                      ข้อมูลผู้เข้าร่วมประชุม
                      <v-chip
                          class="ml-2"
                          color="green"
                          dark>
              <span v-if="Cordi_Count == '0'">
                {{ this.JoinMeet.length }} / ไม่จำกัด
              </span>
                        <span v-else>
                {{ this.JoinMeet.length }} / {{ Count }}
              </span>
                      </v-chip>
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="DataMeeting"
                    >
                      <v-card>
                        <v-card-title>
            <span class="font-weight-bold">
              เพิ่มข้อมูลการจัดประชุม
            </span>
                        </v-card-title>
                        <v-card-text>
                          <v-list>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="8"
                                >
                                  <v-text-field
                                      label="หัวข้อการจัดประชุม"
                                      outlined
                                      v-model="Topic"
                                      :error="Topic == ''"
                                      :error-messages="Topic == '' ? 'หัวข้อการประชุม (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-radio-group row v-model="Cordi_Count" @change="ChooseCordiCount">
                                    <v-radio label="ไม่จำกัดผู้เข้าร่วม" value="0"></v-radio>
                                    <v-radio label="จำกัดผู้เข้าร่วม" value="1"></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item v-if="Cordi_Count == '1'">
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="4">
                                  <v-text-field
                                      label="จำนวนผู้เข้าร่วม"
                                      type="number"
                                      outlined
                                      v-model="Count"
                                      :error="Count == ''"
                                      :error-messages="Count == '' ? 'จำนวนผู้เข้าร่วม (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                  <div align="center">
                                    <p class="font-weight-bold">
                                      วันที่เริ่มต้นจัดงาน
                                    </p>
                                    <v-date-picker
                                        class="ma-10"
                                        v-model="Date_start"
                                        :landscape="false"
                                        locale="th"
                                        :color="Date_start == '' ? 'red' : 'primary'"
                                    ></v-date-picker>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <div align="center">
                                    <p class="font-weight-bold">
                                      วันที่สิ้นสุดจัดงาน
                                    </p>
                                    <v-date-picker
                                        class="ma-10"
                                        v-model="Date_end"
                                        :landscape="false"
                                        locale="th"
                                        :color="Date_end == '' ? 'red' : 'primary'"
                                    ></v-date-picker>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-text-field
                                      type="time"
                                      label="เวลาเริ่มต้น"
                                      outlined
                                      v-model="Time_start"
                                      :error="Time_start == ''"
                                      :error-messages="Time_start == '' ? 'เวลาเริ่มต้น (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-text-field
                                      type="time"
                                      label="เวลาสิ้นสุด"
                                      outlined
                                      v-model="Time_end"
                                      :error="Time_end == ''"
                                      :error-messages="Time_end == '' ? 'เวลาสิ้นสุด (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-autocomplete
                                      v-model="DepSelect"
                                      label="จัดโดย (หน่วยงาน)"
                                      :items="depart"
                                      item-text="dep_name"
                                      item-value="dep_id"
                                      outlined
                                      :error="DepSelect == ''"
                                      :error-messages="DepSelect == '' ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-text-field
                                      label="สถานที่จัด"
                                      outlined
                                      v-model="Place"
                                      :error="Place == ''"
                                      :error-messages="Place == '' ? 'สถานที่จัด (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      required

                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-textarea v-model="Rm" label="รายละเอียด (ถ้ามี)" outlined></v-textarea>
                            </v-list-item>
                            <v-list-item>
                              <v-file-input
                                  v-model="files"
                                  color="deep-purple accent-4"
                                  counter
                                  label="แนบไฟล์เอกสารประกอบการประชุม"
                                  multiple
                                  placeholder="เลือกไฟล์"
                                  prepend-icon="mdi-paperclip"
                                  outlined
                                  :show-size="1000"
                                  @change="FileSelect"
                              >
                                <template v-slot:selection="{ index, text }">
                                  <v-chip
                                      v-if="index < 5"
                                      color="deep-purple accent-4"
                                      dark
                                      label
                                      small
                                  >
                                    {{ text }}
                                  </v-chip>

                                  <span
                                      v-else-if="index === 5"
                                      class="overline grey--text text--darken-3 mx-2"
                                  >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                                </template>
                              </v-file-input>
                            </v-list-item>
                            <v-list-item>
                              <v-alert
                                  v-if="alert"
                                  prominent
                                  type="error"
                              >
                                <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                </v-row>
                              </v-alert>
                            </v-list-item>
                            <v-list-item v-if="FileMeeting.length > 0">
                              <template>
                                <v-row>
                                  <v-col cols="12" sm="6" offset-sm="3">
                                    <v-card>
                                      <v-card-title>
                                        ไฟล์ภาพประกอบ
                                      </v-card-title>
                                      <v-container fluid>
                                        <v-row>
                                          <v-col
                                              v-for="(file_i, index) in FileMeeting"
                                              :key="index"
                                              class="d-flex child-flex"
                                              cols="12"
                                              md="4"
                                          >
                                            <v-card flat tile class="d-flex">
                                              <v-img
                                                  v-if="file_i.type == 'image'"
                                                  :src="file_i.src"
                                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                  aspect-ratio="1"
                                                  class="grey lighten-2"
                                              >
                                                <template v-slot:placeholder>
                                                  <v-row
                                                      class="fill-height ma-0"
                                                      align="center"
                                                      justify="center"
                                                  >
                                                    <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-img
                                                  v-if="file_i.type == 'pdf'"
                                                  src="../assets/Image/pdf.png"
                                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                  aspect-ratio="1"
                                                  class="grey lighten-2"
                                              >
                                                <template v-slot:placeholder>
                                                  <v-row
                                                      class="fill-height ma-0"
                                                      align="center"
                                                      justify="center"
                                                  >
                                                    <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-card-actions>
                                                <v-btn text @click="ShowData(file_i.src)">
                                                  <!--                                              <v-btn text @click="ShowData(Openfile + file_i.File_path)">-->
                                                  <span style="color: indigo">
                                                                                              เรียกดู
                                                                                          </span>
                                                </v-btn>
                                              </v-card-actions>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-list-item>
                            <v-card v-if="FileMeetingToDb.length > 0">
                              <v-card-subtitle>
                                <span>
                                  ไฟล์ประกอบ
                                </span>
                              </v-card-subtitle>
                              <div v-for="(file, idx) in FileMeetingToDb" :key="idx">
                                <v-btn text @click="ShowData(Openfile + file.File_path)" color="blue"
                                       class="text--darken-4">
                                  ไฟล์ที่ {{ idx + 1 }} : {{ file.File_name }}
                                </v-btn>
                                <v-btn text @click="DelPic(file.id,idx)" class="ml-6" color="red">
                                  ลบ
                                </v-btn>
                              </div>
                            </v-card>
                            <v-list-item class="justify-center">
                              <v-radio-group row v-model="Register_Cordi">
                                <v-radio label="ปิดลงทะเบียน" value="0" color="red"></v-radio>
                                <v-radio label="เปิดลงทะเบียน" value="1" color="green"></v-radio>
                              </v-radio-group>
                            </v-list-item>
                            <v-list-item v-if="Register_Cordi == '1'">
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                  <div align="center">
                                    <v-text-field
                                        v-model="Date_reg_start"
                                        type="date"
                                        label="วันที่เปิดลงทะเบียน"
                                        outlined
                                        :error="Date_reg_start == '0000-00-00'"
                                        :error-messages="Date_reg_start == '0000-00-00' ? 'วันที่เปิดลงทะเบียน (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        required
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <div align="center">
                                    <v-text-field
                                        v-model="Date_reg_end"
                                        type="date"
                                        label="วันที่สิ้นสุดลงทะเบียน"
                                        outlined
                                        :error="Date_reg_end == '0000-00-00'"
                                        :error-messages="Date_reg_end == '0000-00-00' ? 'วันที่สิ้นสุดลงทะเบียน (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        required
                                    ></v-text-field>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item class="mt-7">
                              <v-text-field label="รหัสอ้างอิงการประชุม" outlined v-model="LinkGen"
                                            readonly></v-text-field>
                            </v-list-item>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="10">
                                  <v-text-field label="ลิงค์เว็บไซต์รับสมัคร" outlined v-model="url"
                                                readonly></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2">
                                  <CopyToClipboard :text="url">
                                    <v-btn
                                        outlined
                                        color="puple"
                                        @click="Copy"
                                    >
                                      คัดลอกลิงค์
                                    </v-btn>
                                  </CopyToClipboard>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                        key="DataJoinMeeting"
                    >
                      <v-card>
                        <v-card-title>
            <span class="font-weight-bold">
              เพิ่มข้อมูลผู้เข้าร่วมประชุม
            </span>
                        </v-card-title>
                        <v-card-text>
                          <v-list>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-autocomplete
                                      v-model="staffSel"
                                      label="ค้นหาบุคลากร"
                                      :items="staffData"
                                      item-text="customDetail"
                                      item-value="perid"
                                      hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                      persistent-hint
                                      clearable
                                      outlined
                                      @keyup="checkKeyEnter"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2">
                                  <v-btn
                                      class="mt-2"
                                      outlined
                                      color="primary"
                                      @click="InsertJoinMeet">
                                    เพิ่ม
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <div align="center" style="font-size: 20px">
                              ผู้เข้าร่วมทั้งหมด {{ JoinMeet.length }} คน
                              ลงทะเบียน <span
                                style="font-weight: bold;color: #42b983">{{
                                JoinMeet.filter(item => item.status_reg == '1').length
                              }}</span>
                              คน / รอลงทะเบียน <span
                                style="font-weight: bold;color: red">{{
                                JoinMeet.filter(item => item.status_reg == '0').length
                              }}</span>
                              คน
                            </div>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-text-field v-model="search" label="ค้นหา"></v-text-field>
                            </v-list-item>
                            <div align="center">
                              <download-excel
                                  class="btn btn-default"
                                  :data="json_data"
                                  :fields="json_fields"
                                  worksheet="รายชื่อ"
                                  :title="array_title"
                                  :name="'รายชื่อผู้เข้าร่วมงาน ' + MeetingObj.Topic + '.xls'"
                                  v-if="MeetingObj != null"
                              >
                                <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                  Export ข้อมูล
                                </v-btn>
                              </download-excel>
                            </div>
                            <v-list-item class="d-flex justify-center mt-6">
                              <v-data-table
                                  :search="search"
                                  :headers="JoinMeetHeader"
                                  :items="JoinMeet">
                                <template v-slot:item.action="{item}">
                                  <v-btn color="red"
                                         @click="DelData(item.idx)"
                                         outlined
                                  >
                                    ลบ
                                  </v-btn>
                                </template>
                                <template v-slot:item.status_reg="{item}">
                                  <v-radio-group row v-model="item.status_reg">
                                    <v-radio label="ลงทะเบียน" value="1" color="green"></v-radio>
                                    <v-radio label="รอลงทะเบียน" value="0" color="red"></v-radio>
                                  </v-radio-group>
                                </template>
                              </v-data-table>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-container>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogOpenReg"
          width="800"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            กรุณาระบุวันที่ เปิด - ปิด การลงทะเบียน
          </v-card-title>

          <v-card-text>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="6"
                >
                  <div align="center">
                    <v-text-field
                        v-model="Date_reg_start2"
                        type="date"
                        label="วันที่เปิดลงทะเบียน"
                        outlined
                        :error="Date_reg_start2 == ''"
                        :error-messages="Date_reg_start2 == '' ? 'วันที่เปิดลงทะเบียน (ห้ามว่าง)' : ''"
                        persistent-hint
                        required
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col
                    cols="12"
                    md="6">
                  <div align="center">
                    <v-text-field
                        v-model="Date_reg_end2"
                        type="date"
                        label="วันที่สิ้นสุดลงทะเบียน"
                        outlined
                        :error="Date_reg_end2 == ''"
                        :error-messages="Date_reg_end2 == '' ? 'วันที่สิ้นสุดลงทะเบียน (ห้ามว่าง)' : ''"
                        persistent-hint
                        required
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="SaveOpenReg"
            >
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogFile"
          width="800"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            ไฟล์ประกอบ (เพิ่มเติม)
          </v-card-title>

          <v-card-text class="mt-6">
            <div v-if="FileMeetingToDb2.length > 0">
              <div v-for="(file, idx) in FileMeetingToDb2" :key="idx">
                <v-btn text @click="ShowData(Openfile + file.File_path)" color="blue"
                       class="text--darken-4">
                  ไฟล์ที่ {{ idx + 1 }} : {{ file.File_name }}
                </v-btn>
              </div>
            </div>
            <div align="center" v-else>
              <span style="font-weight: bold;color: red">ไม่มีข้อมูลไฟล์ประกอบเพิ่มเติม</span>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                text
                @click="dialogFile = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogShowDetail"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogShowDetail = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="font-weight-bold text-md-h3 text-sm-h6 text-xs-h6" v-if="MeetingObj != null">
              {{ this.MeetingObj.Topic }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  @click="dialogShowDetail = false"
                  color="red"
              >
                <v-icon>mdi-close</v-icon>
                <span style="font-size: 24px;">ปิด</span>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list>
            <v-card-text v-if="MeetingObj != null">
              <v-list class="mt-10">
                <v-list-item class="justify-center">
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="8"
                    >
                      <v-list-item>
                    <span class="font-weight-bold text-md-h6">
                หัวข้อประชุม : {{ this.MeetingObj.Topic }}
              </span>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                    <span class="font-weight-bold text-md-h6">
                สถานที่จัด : {{ this.MeetingObj.Place }}
              </span>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                     <span class="font-weight-bold text-md-h6"
                           v-if="MeetingObj.Date_start == MeetingObj.Date_end">
                วันที่จัด : {{ this.MeetingObj.Date_start | DateToThai }} เวลา {{ this.MeetingObj.Time_start }} น. - {{
                         this.MeetingObj.Time_end
                       }} น.
              </span>
                        <span class="font-weight-bold text-md-h6" v-else>
                วันที่จัด : {{
                            this.MeetingObj.Date_start | DateToThai
                          }} - {{ this.MeetingObj.Date_end | DateToThai }} | เวลา {{ this.MeetingObj.Time_start }} น. - {{
                            this.MeetingObj.Time_end
                          }} น.
              </span>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                     <span class="font-weight-bold text-md-h6"
                           v-if="MeetingObj.Date_reg_start == MeetingObj.Date_reg_end">
                วันที่จัดเปิดลงทะเบียน : {{
                         this.MeetingObj.Date_reg_start | DateToThai
                       }} จำนวนผู้เข้าร่วม {{ (MeetingObj.Count_cordi == '0' ? 'ไม่จำกัด' : MeetingObj.Count + ' คน') }}
              </span>
                        <span class="font-weight-bold text-md-h6" v-else>
                วันที่จัดเปิดลงทะเบียน : {{
                            this.MeetingObj.Date_reg_start | DateToThai
                          }} - {{ this.MeetingObj.Date_reg_end | DateToThai }}
              </span>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                     <span class="font-weight-bold text-md-h6">
                จำกัดผู้เข้าร่วม : {{ (MeetingObj.Count_cordi == '0' ? 'ไม่จำกัด' : MeetingObj.Count + ' คน') }}
              </span>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                     <span class="font-weight-bold text-md-h6">
                รายละเอียดเพิ่มเติม :
                       <v-btn text color="primary" @click="dialogDetail = true">
                       Click!!
                     </v-btn>
              </span>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search2" label="ค้นหา"></v-text-field>
                </v-list-item>
                <div align="center" style="font-size: 20px">
                  ผู้เข้าร่วมทั้งหมด {{ JoinMeet.length }} /
                  {{ (MeetingObj.Count_cordi == '0' ? 'ไม่จำกัด' : MeetingObj.Count) }} คน |
                  ลงทะเบียน <span
                    style="font-weight: bold;color: #42b983">{{
                    JoinMeet.filter(item => item.status_reg == '1').length
                  }}</span>
                  คน / รอลงทะเบียน <span
                    style="font-weight: bold;color: red">{{
                    JoinMeet.filter(item => item.status_reg == '0').length
                  }}</span>
                  คน
                </div>
                <v-list-item class="d-flex justify-center mt-6">
                  <v-data-table
                      :search="search2"
                      :headers="JoinMeetHeader"
                      :items="JoinMeet">
                    <template v-slot:item.status_reg="{item}">
                  <span style="font-weight: bold;color: #42b983" class="darken-4" v-if="item.status_reg == '1'">
                    ลงทะเบียน
                  </span>
                      <span style="font-weight: bold;color: red" class="darken-4" v-else>
                    รอลงทะเบียน
                  </span>
                    </template>
                  </v-data-table>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-list>

        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogDetail"
          width="800"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            รายละเอียดประกอบ (เพิ่มเติม)
          </v-card-title>
          <v-card-text class="mt-6" v-if="MeetingObj != null">
            <div class="mt6">
              <span style="font-weight: bold;color: blue">รายละเอียดประกอบ</span>
            </div>
            <div v-if="MeetingObj.Rm != ''">
              <span style="font-size: 20px;color: black">{{ MeetingObj.Rm }}</span>
            </div>
            <div align="center" v-else>
              <span style="font-weight: bold;color: red">ไม่มีรายละเอียดประกอบเพิ่มเติม</span>
            </div>
            <v-divider></v-divider>
            <div class="mt6">
              <span style="font-weight: bold;color: blue">ไฟล์ประกอบ</span>
            </div>
            <div v-if="FileMeetingToDb.length > 0">
              <div v-for="(file, idx) in FileMeetingToDb" :key="idx">
                <v-btn text @click="ShowData(Openfile + file.File_path)" color="blue"
                       class="text--darken-4">
                  ไฟล์ที่ {{ idx + 1 }} : {{ file.File_name }}
                </v-btn>
                <p style="color: #ff6d81;font-size: 12px" class="ml-16">
                  อัพโหลดโดย :
                  {{ staffData.filter(item => item.perid == file.Create_By).length > 0 ? staffData.filter(item => item.perid == file.Create_By)[0].custom_Detail : 'ไม่พบข้อมูลรหัสบุคลา่กร - ' + file.Create_By }}
                  <v-btn text @click="deleteFileExec(file.id)" class="ml-6" color="red">
                    ลบ
                  </v-btn>
                </p>
              </div>
            </div>
            <div align="center" v-else>
              <span style="font-weight: bold;color: red">ไม่มีข้อมูลไฟล์ประกอบเพิ่มเติม</span>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-list-item class="text-center justify-center ma-4">
            <v-btn outlined @click="(!upload ? upload = true : closeUpload())" :color="!upload? 'green':'red'">{{(!upload? 'อัพโหลดไฟล์':'ยกเลิกการอัพโหลดไฟล์')}}</v-btn>
          </v-list-item>
          <template v-if="upload">
            <v-list-item>
              <v-file-input
                  v-model="files"
                  color="deep-purple accent-4"
                  counter
                  label="แนบไฟล์เอกสารประกอบการประชุม"
                  multiple
                  placeholder="เลือกไฟล์"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="FileSelect"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                      v-if="index < 5"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                  >
                    {{ text }}
                  </v-chip>

                  <span
                      v-else-if="index === 5"
                      class="overline grey--text text--darken-3 mx-2"
                  >
                                +{{ files.length - 2 }} File(s)
                              </span>
                </template>
              </v-file-input>
            </v-list-item>
            <v-list-item>
              <v-alert
                  v-if="alert"
                  prominent
                  type="error"
              >
                <v-row align="center" v-for="item in txtAlert" :key="item.id">
                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                </v-row>
              </v-alert>
            </v-list-item>
            <v-list-item v-if="FileMeeting.length > 0">
              <template>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        ไฟล์ภาพประกอบ
                      </v-card-title>
                      <v-container fluid>
                        <v-row>
                          <v-col
                              v-for="(file_i, index) in FileMeeting"
                              :key="index"
                              class="d-flex child-flex"
                              cols="12"
                              md="4"
                          >
                            <v-card flat tile class="d-flex">
                              <v-img
                                  v-if="file_i.type == 'image'"
                                  :src="file_i.src"
                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                  aspect-ratio="1"
                                  class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                      class="fill-height ma-0"
                                      align="center"
                                      justify="center"
                                  >
                                    <v-progress-circular
                                        indeterminate
                                        color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                              <v-img
                                  v-if="file_i.type == 'pdf'"
                                  src="../assets/Image/pdf.png"
                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                  aspect-ratio="1"
                                  class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                      class="fill-height ma-0"
                                      align="center"
                                      justify="center"
                                  >
                                    <v-progress-circular
                                        indeterminate
                                        color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                              <v-card-actions>
                                <v-btn text
                                       @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
          </template>
          <v-list-item class="text-center justify-center" v-if="upload">
            <v-btn outlined @click="uploadFilesExec" color="green">บันทึก</v-btn>
          </v-list-item>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                text
                @click="dialogDetail = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>

<script>
import Vue from 'vue'
import {mapActions, mapGetters} from "vuex";
import CopyToClipboard from "vue-copy-to-clipboard";
import axios from "axios";
import ConstData from "@/const/Const";

var TinyURL = require('tinyurl');

export default {
  name: "JoinMeetingPerson",
  components: {
    CopyToClipboard
  },
  data() {
    return {
      upload: false,
      maintain: false,
      dialogFile: false,
      dialogDetail: false,
      dialogShowDetail: false,
      Date_reg_start2: '',
      Date_reg_end2: '',
      dialogOpenReg: false,
      Register_Cordi: '0',
      codePermiss: '11001',
      CheckAdmin: false,
      CheckSubAdmin: false,
      MeetFilter: '0',
      loading: false,
      dialogLoading: false,
      array_title: [],
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name_old',
        "กลุ่มหน่วยงาน": 'dep_group_name',
        "ตำแหน่ง": 'pos_name',
        // "ศาสนา": 'religion_name',
        // "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        // "หมายเหตุ": 'remark',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      DelFileId: [],
      JoinDel: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      MeetingObj: null,
      dialogEdit: false,
      search: '',
      search2: '',
      HeaderMeeting: [
        {text: 'หัวข้อประชุม', value: 'Topic_Custom'},
        {text: 'ทำรายการ', value: 'action'}
      ],
      MeetingDataDump: [],
      MeetingDataAll: [],
      Rm: '', // ข้อมูลตัวแปรเก่าจาก ManageMeeting
      files: [],
      alert: false,
      txtAlert: [],
      FileMeeting: [],
      FileMeetingToDb: [],
      FileMeetingToDb2: [],
      searchPerson: '',
      staffSel: '',
      tab: 'DataMeeting',
      Topic: '',
      Count: '0',
      Date_start: '',
      Date_reg_start: '',
      Date_end: '',
      Date_reg_end: '',
      Time_start: '',
      Time_end: '',
      DepSelect: '',
      Place: '',
      LinkGen: '',
      url: '',
      Cordi_Count: '0',
      Ref_id: '',
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      headerAxiosDel: {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      },
      JoinMeetHeader: [
        {text: 'ลำดับ', value: 'idx'},
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'dep_name'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
        {text: '', value: 'action'}
      ],
      JoinMeet: [], // สิ้นสุดข้อมูลตัวแปรเก่าจาก ManageMeeting
      JoinMeetByPerson: [] // สิ้นสุดข้อมูลตัวแปรเก่าจาก ManageMeeting
    }
  },
  computed: {
    ...mapGetters({
      MeetingData: 'Meeting/getMeetingData',
      JoinMeetingData: 'Meeting/getJoinMeetingData',
      JoinMeetingDataByPerson: 'Meeting/getJoinMeetingDataByPerson',
      FilesData: 'Meeting/getFileData',
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      depart: 'Depart/getDepart',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      MenuPermiss: 'Permission/getMenuPermiss',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initMeetingData: 'Meeting/initMeetingData',
      initJoinMeetingData: 'Meeting/initJoinMeetingData',
      getJoinMeetingDataByPerson: 'Meeting/getJoinMeetingDataByPerson',
      initFileData: 'Meeting/initFileData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      getPermissionDep: 'Permission/getPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionData: 'Permission/getPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
    }),
    init() {
      this.dialogLoading = true
      this.MeetingDataDump = []
      this.MeetingDataAll = []
      this.MeetingDataOld = []
      this.MeetFilter = '0'
      var MeetingDump = []
      this.initMeetingData().then(res => {
        if (res) {
          if (this.MeetingData.length > 0) {
            this.MeetingData.map(item => {
              MeetingDump.push({
                ...item,
                Topic_Custom: (item.Reg_status == '1') ? '<span style="font-weight: bold;color: #364eff;font-size: 15px">เรื่อง : ' + item.Topic + '</span>' +
                    '<div><span style="font-weight: bold;color: #42b983">วันที่ลงทะเบียน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_reg_start) : Vue.filter('DateToThai')(item.Date_reg_start) + ' - ' + Vue.filter('DateToThai')(item.Date_reg_end)) + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">วันที่จัดงาน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_start) : Vue.filter('DateToThai')(item.Date_start) + ' - ' + Vue.filter('DateToThai')(item.Date_end)) + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">เวลา : ' + item.Time_start + ' น. - ' + item.Time_end + ' น.' + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">สถานที่ : ' + item.Place + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">จำกัดผู้เข้าร่วม : ' + (item.Count_cordi == '0' ? 'ไม่จำกัด' : item.Count + ' คน') + '</span></div>' +
                    '<div><span style="font-weight: bold;color: #ff6d81">' + item.dep_name + '</span></div>' :
                    '<span style="font-weight: bold;color: #364eff;font-size: 15px">เรื่อง : ' + item.Topic + '</span>' +
                    '<div><span style="font-weight: bold;color: red">ปิดลงทะเบียน</span></div>' +
                    '<div><span style="font-weight: bold;color: black">วันที่จัดงาน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_start) : Vue.filter('DateToThai')(item.Date_start) + ' - ' + Vue.filter('DateToThai')(item.Date_end)) + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">เวลา : ' + item.Time_start + ' น. - ' + item.Time_end + ' น.' + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">สถานที่ : ' + item.Place + '</span></div>' +
                    '<div><span style="font-weight: bold;color: black">จำกัดผู้เข้าร่วม : ' + (item.Count_cordi == '0' ? 'ไม่จำกัด' : item.Count + ' คน') + '</span></div>' +
                    '<div><span style="font-weight: bold;color: #ff6d81">' + item.dep_name + '</span></div>',
                IsLoading: false,
                IsExport: false,
              })
            })
            this.MeetingDataAll = MeetingDump
            this.MeetingDataDump = MeetingDump.filter(item => item.Reg_status == '1')
          }
        }
        this.dialogLoading = false
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    deleteFileExec(id) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบไฟล์ประกอบการประชุม ใชหรือไม่ ??",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + id, {
            active: '0',
            Update_By: this.MeData[0].perid,
          }, this.headerAxios).then(res => {
            if (res.data.status) {
              this.getFileData()
              this.$swal.fire({
                icon: 'success',
                title: 'ลบไฟล์สำเร็จ!!'
              })
              this.dialogLoading = false
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบไฟล์ได้!!'
              })
              this.dialogLoading = false
            }
          })
        }
      })
    },
    uploadFilesExec() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการอัพโหลดไฟล์ประกอบการประชุม ใชหรือไม่ ??",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.FileMeeting.length > 0) {
            var countFileMeeting = 0
            this.dialogLoading = true
            this.FileMeeting.map((item) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                File_name: item.name,
                File_path: item.path,
                File_type: item.type,
                Ref_id: this.MeetingObj != null ? this.MeetingObj.Ref_id : null,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }, this.headerAxiosPUT).then(res => {
                if (res.data.status) {
                  countFileMeeting++
                  if (countFileMeeting == this.FileMeeting.length) {
                    this.files = []
                    this.FileMeeting = []
                    this.txtAlert = []
                    this.alert = false
                    this.dialogLoading = false
                    this.getFileData()
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ!!'
                    })
                  }
                }
              })
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลไฟล์ที่ต้องการอัพโหลด'
            })
          }
        }
      })
    },
    closeUpload() {
      this.upload = false
      this.files = []
      this.alert = false
      this.FileMeeting = []
      this.txtAlert = []
    },
    getFileData() {
      this.FileMeetingToDb = []
      this.initFileData({
        Ref_id: this.MeetingObj.Ref_id
      }).then(res => {
        if (res) {
          this.FileMeetingToDb = this.FilesData
        }
      }).catch(resErr => {
        if (resErr) {
          this.FileMeetingToDb = []
        }
      })
    },
    formatDateNow() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    ChangeTypeMeeting() {
      if (this.MeetingDataOld.length == 0) {
        this.MeetingDataOld = this.MeetingDataDump
      }
      switch (this.MeetFilter) {
        case "0":
          this.MeetingDataDump = this.MeetingDataOld
          break
        case "1":
          this.MeetingDataDump = this.MeetingDataOld.filter(item => item.Date_start <= this.formatDateNow() && item.Date_end >= this.formatDateNow())

          break
        case "2":
          this.MeetingDataDump = this.MeetingDataOld.filter(item => item.Date_start > this.formatDateNow())
          break
        case "3":
          this.JoinMeetByPerson = []
          this.MeetingDataDump = []
          this.dialogLoading = true
          axios
          .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
            queryName: "getMeetingIsJoinByUser",
            param: btoa(
              JSON.stringify({
                uid: this.MeData[0].perid,
              })
            ),
          }).then((response) => {
            if (response.data.length > 0) {
              this.JoinMeetByPerson = response.data
              if (this.JoinMeetByPerson.length > 0) {
                this.JoinMeetByPerson.map(item => {
                  this.MeetingDataAll.map(item2 => {
                    if (item.uuid == item2.uuid) {
                      this.MeetingDataDump.unshift(item2)
                    }
                  })
                })
              }
              if (this.MeetingDataDump.length == 0) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลงานประชุมที่คุณเคยเข้าร่วม!'
                })
              }
              this.dialogLoading = false
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูลงานประชุมที่คุณเคยเข้าร่วม!'
              })
            }
          }).catch((error) => {
            console.error(error);
            // Handle the error here
            this.dialogLoading = false
            this.MeetingDataDump = []
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลงานประชุมที่คุณเคยเข้าร่วม!'
            })
          })
          break
        default:
          break
      }
    },
    ExportData() {
      this.json_data = []
      this.array_title = []
      this.array_title.push(this.Topic)
      this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(this.Date_end))
      this.array_title.push('สถานที่ ' + this.Place)
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet.filter(item => item.status_reg == '1')
        JoinMeetDump = JoinMeetDump.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
        JoinMeetDump.map((item, idx) => {
          if (parseInt(item.salary) > 20000) {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '15500'
            })
          } else {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '11000'
            })
          }
        })
      }
    },
    GenerateLink(item) {
      this.CheckPermission().then(res => {
        if (res) {
// this.LinkGen = this.$uuid.v1()
          this.GenerateUrl(item).then(res => {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + item.id, {
              url: res,
              update_by: this.MeData[0].perid,
            }, this.headerAxios).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'สร้าง Short Url การประชุม ' + item.Topic + ' ใหม่สำเร็จ'
                })
                this.init()
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาดไม่สามารถสร้าง Short Url ได้!!'
                })
              }
            })
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    fetchJoinMeetData(item) {
      item.IsLoading = true
      this.initJoinMeetingData({
        uuid: item.uuid
      }).then(res => {
        if (res) {
          this.JoinMeet = this.JoinMeetingData
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
            item.IsDb = true
          })
          item.IsLoading = false
          item.IsExport = true
        }
      }).catch(res => {
        if (res) {
          item.IsLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมประชุม'
          })
        }
      })
    },
    ExportData2(item) {
      this.json_data = []
      this.array_title = []
      this.array_title.push(item.Topic)
      this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(item.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(item.Date_end))
      this.array_title.push('สถานที่ ' + item.Place)
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet.filter(item => item.status_reg == '1')
        JoinMeetDump = JoinMeetDump.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
        JoinMeetDump.map((item, idx) => {
          if (parseInt(item.salary) > 20000) {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '15500'
            })
          } else {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '11000'
            })
          }
        })
      }
      setTimeout(() => {
        item.IsExport = false
      }, 1000)
    },
    DelPic(id, idx) {
      this.DelFileId.push(id)
      this.FileMeetingToDb.splice(idx, 1)
    },
    DelMeeting(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "คุณต้องการลบข้อมูลการประชุม " + item.Topic + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              this.dialogLoading = true
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + item.id, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, this.headerAxios).then(res => {
                if (res.data.status) {
                  this.$swal.fire({
                    icon: 'success',
                    title: 'ลบข้อมูลประชุม ' + item.Topic + ' สำเร็จ'
                  })
                  this.init()
                  this.dialogLoading = false
                }
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    EditMeeting(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.DelFileId = []
          this.JoinDel = []
          this.JoinMeet = []
          this.MeetingObj = null
          this.MeetingObj = item
          this.dialogEdit = true
          this.tab = 'DataMeeting'
          this.Topic = item.Topic
          this.Count = item.Count
          this.Date_start = item.Date_start
          this.Date_reg_start = item.Date_reg_start
          this.Date_end = item.Date_end
          this.Date_reg_end = item.Date_reg_end
          this.Time_start = item.Time_start
          this.Time_end = item.Time_end
          this.DepSelect = item.dep_id
          this.Place = item.Place
          this.LinkGen = item.uuid
          this.url = item.url
          this.Rm = item.Rm
          this.Register_Cordi = item.Reg_status
          this.Ref_id = item.Ref_id
          this.Cordi_Count = item.Count_cordi
          this.initJoinMeetingData({
            uuid: item.uuid
          }).then(res => {
            if (res) {
              this.JoinMeet = this.JoinMeetingData
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
                item.IsDb = true
              })
            }
          })
          this.initFileData({
            Ref_id: item.Ref_id
          }).then(res => {
            if (res) {
              this.FileMeetingToDb = this.FilesData
            }
          }).catch(resErr => {
            if (resErr) {
              this.FileMeetingToDb = []
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    Copy() {
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์',
        showConfirmButton: false,
        timer: 1000
      })
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileMeeting = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type,
                  })
                  break
                case 'application/pdf':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type,
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileMeetingPdf = []
              //     this.FileMeeting = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }

    },
    DelData(idx) {
      this.JoinMeet.map((item, idx2) => {
        if (item.idx == idx) {
          this.JoinDel.push(item.id)
          this.JoinMeet.splice(idx2, 1)
        }
      })
      this.staffSel = ''
    },
    InsertJoinMeet() {
      if (this.JoinMeet.length > 0) {
        if (this.JoinMeet.filter(item => item.perid == this.staffSel).length > 0) {
          this.staffSel = ''
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
          })
        } else {
          var Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              // idx: this.JoinMeet.length + 1,
              status_reg: '0',
              IsDb: false
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
      } else {
        Staff = this.staffData.filter(item => item.perid == this.staffSel)
        if (Staff.length > 0) {
          this.JoinMeet.unshift({
            ...Staff[0],
            // idx: this.JoinMeet.length + 1,
            status_reg: '0',
            IsDb: false
          })
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
          })
        }
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        if (this.JoinMeet.length > 0) {
          if (this.JoinMeet.filter(item => item.perid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var Staff = this.staffData.filter(item => item.perid == this.staffSel)
            if (Staff.length > 0) {
              this.JoinMeet.unshift({
                ...Staff[0],
                // idx: 0,
                status_reg: '0',
                IsDb: false
              })
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }
        } else {
          Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              // idx: this.JoinMeet.length + 1
              status_reg: '0',
              idx: 0
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
        this.staffSel = ''
      }
    },
    GenerateUrl(item) {
      return new Promise(resolve => {
        TinyURL.shorten(ConstData.PreGenerateLink + item.uuid).then(function (res) {
          resolve(res)
        }, function (err) {
          console.log(err)
        })
      })
    },
    ChooseCordiCount() {
      if (this.Cordi_Count == '0') {
        this.Count = '0'
      }
    },
    EditMeetingExec() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.Topic == '' || this.Date_start == '' || this.Date_end == ''
              || this.Time_start == '' || this.Time_end == '' || this.dep_id == '' || this.Place == ''
              || this.uuid == '' || this.url == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดกรอกข้อมูล ช่องสีแดงให้ครบถ้วน !!'
            })
          } else if (this.Date_start > this.Date_end) {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดกรอกข้อมูลวันที่จัดงานให้ถูกต้อง'
            })
          } else if (this.Register_Cordi == '1') {
            if (this.Date_reg_start == '0000-00-00' || this.Date_reg_end == '0000-00-00') {
              this.$swal.fire({
                icon: 'error',
                title: 'โปรดกรอกข้อมูลวันที่เปิดรับลงทะเบียน'
              })
            } else if (this.Date_reg_start > this.Date_reg_end) {
              this.$swal.fire({
                icon: 'error',
                title: 'โปรดกรอกข้อมูลวันที่เปิดรับลงทะเบียนให้ถูกต้อง'
              })
            }
          } else {
            if (this.Cordi_Count == '1' && parseInt(this.Count) == 0) {
              this.$swal.fire({
                icon: 'error',
                title: 'โปรดระบุจำนวนผู้เข้าร่วมประชุม ให้ถูกต้อง'
              })
            } else {
              this.dialogLoading = true
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + this.MeetingObj.id, {
                Topic: this.Topic,
                Count_cordi: this.Cordi_Count,
                Count: this.Count,
                Date_start: this.Date_start,
                Date_end: this.Date_end,
                Date_reg_start: this.Date_reg_start,
                Date_reg_end: this.Date_reg_end,
                Time_start: this.Time_start,
                Time_end: this.Time_end,
                Rm: this.Rm,
                Reg_status: this.Register_Cordi,
                Ref_id: this.Ref_id,
                dep_id: this.DepSelect,
                Place: this.Place,
                uuid: this.LinkGen,
                url: this.url,
                create_by: this.MeData[0].perid,
                create_time: 'now()',
              }, this.headerAxios).then(res => {
                if (res.data.status) {
                  if (this.JoinMeet.length > 0) {
                    var countInsert = 0
                    if (this.JoinDel.length > 0) {
                      for (var j = 0; j <= this.JoinDel.length - 1; j++) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join/id/' + this.JoinDel[j], {
                          active: '0',
                          update_by: this.MeData[0].perid,
                        }, this.headerAxios)
                      }
                    }
                    this.JoinMeet.map(Join_i => {
                      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join/id/' + Join_i.id).then(resGet => {
                        if (resGet.data) {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join/id/' + Join_i.id, {
                            status_reg: Join_i.status_reg,
                            update_by: this.MeData[0].perid,
                          }, this.headerAxios).then(resJoinMeet => {
                            if (resJoinMeet.status) {
                              countInsert++
                              if (countInsert == this.JoinMeet.length) {
                                if (this.FileMeeting.length > 0) {
                                  var countFileMeeting = 0
                                  this.FileMeeting.map((item) => {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                      File_name: item.name,
                                      File_path: item.path,
                                      File_type: item.type,
                                      Ref_id: this.Ref_id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }, this.headerAxiosPUT).then(res => {
                                      if (res.data.status) {
                                        countFileMeeting++
                                        if (countFileMeeting == this.FileMeeting.length) {
                                          if (this.DelFileId.length > 0) {
                                            for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                                                active: '0',
                                                Update_By: this.MeData[0].perid,
                                              }, this.headerAxios)
                                            }
                                          }
                                          this.Topic = ''
                                          this.Cordi_Count = '0'
                                          this.Count = '0'
                                          this.Date_start = ''
                                          this.Date_end = ''
                                          this.Time_start = ''
                                          this.Time_end = ''
                                          this.DepSelect = ''
                                          this.Place = ''
                                          this.LinkGen = ''
                                          this.url = ''
                                          this.Place = ''
                                          this.Rm = ''
                                          this.Ref_id = ''
                                          this.JoinMeet = []
                                          this.files = []
                                          this.FileMeeting = []
                                          this.txtAlert = []
                                          this.alert = false
                                          this.tab = 'DataMeeting'
                                          this.staffSel = ''
                                          this.init()
                                          this.dialogEdit = false
                                          this.dialogLoading = false
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                          })
                                        }
                                      }
                                    })
                                  })
                                } else {
                                  if (this.DelFileId.length > 0) {
                                    for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                                        active: '0',
                                        Update_By: this.MeData[0].perid,
                                      }, this.headerAxios)
                                    }
                                  }
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Ref_id = ''
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.dialogEdit = false
                                  this.dialogLoading = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            }
                          })
                        } else {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join', {
                            perid: Join_i.perid,
                            D_meeting_uuid: this.LinkGen,
                            status_reg: Join_i.status_reg,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, this.headerAxiosPUT).then(resJoinMeet => {
                            if (resJoinMeet.status) {
                              countInsert++
                              if (countInsert == this.JoinMeet.length) {
                                if (this.FileMeeting.length > 0) {
                                  var countFileMeeting = 0
                                  this.FileMeeting.map((item) => {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                      File_name: item.name,
                                      File_path: item.path,
                                      File_type: item.type,
                                      Ref_id: this.Ref_id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }, this.headerAxiosPUT).then(res => {
                                      if (res.data.status) {
                                        countFileMeeting++
                                        if (countFileMeeting == this.FileMeeting.length) {
                                          if (this.DelFileId.length > 0) {
                                            for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                                                active: '0',
                                                Update_By: this.MeData[0].perid,
                                              }, this.headerAxios)
                                            }
                                          }
                                          this.Topic = ''
                                          this.Cordi_Count = '0'
                                          this.Count = '0'
                                          this.Date_start = ''
                                          this.Date_end = ''
                                          this.Time_start = ''
                                          this.Time_end = ''
                                          this.DepSelect = ''
                                          this.Place = ''
                                          this.LinkGen = ''
                                          this.url = ''
                                          this.Place = ''
                                          this.Rm = ''
                                          this.Ref_id = ''
                                          this.JoinMeet = []
                                          this.files = []
                                          this.FileMeeting = []
                                          this.txtAlert = []
                                          this.alert = false
                                          this.tab = 'DataMeeting'
                                          this.staffSel = ''
                                          this.init()
                                          this.dialogEdit = false
                                          this.dialogLoading = false
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                          })
                                        }
                                      }
                                    })
                                  })
                                } else {
                                  if (this.DelFileId.length > 0) {
                                    for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                                        active: '0',
                                        Update_By: this.MeData[0].perid,
                                      }, this.headerAxios)
                                    }
                                  }
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Ref_id = ''
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.dialogEdit = false
                                  this.dialogLoading = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            }
                          })
                        }
                      })

                    })

                  } else {
                    if (this.FileMeeting.length > 0) {
                      var countFileMeeting = 0
                      this.FileMeeting.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                          File_name: item.name,
                          File_path: item.path,
                          File_type: item.type,
                          Ref_id: this.Ref_id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }, this.headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            countFileMeeting++
                            if (countFileMeeting == this.FileMeeting.length) {
                              if (this.DelFileId.length > 0) {
                                for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                                    active: '0',
                                    Update_By: this.MeData[0].perid,
                                  }, this.headerAxios)
                                }
                              }
                              this.Topic = ''
                              this.Cordi_Count = '0'
                              this.Count = '0'
                              this.Date_start = ''
                              this.Date_end = ''
                              this.Date_reg_start = ''
                              this.Date_reg_end = ''
                              this.Time_start = ''
                              this.Time_end = ''
                              this.DepSelect = ''
                              this.Place = ''
                              this.LinkGen = ''
                              this.url = ''
                              this.Place = ''
                              this.Rm = ''
                              this.Register_Cordi = ''
                              this.Ref_id = ''
                              this.JoinMeet = []
                              this.files = []
                              this.FileMeeting = []
                              this.txtAlert = []
                              this.alert = false
                              this.tab = 'DataMeeting'
                              this.staffSel = ''
                              this.init()
                              this.dialogEdit = false
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                              })
                            }
                          }
                        })
                      })
                    } else {
                      if (this.DelFileId.length > 0) {
                        for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                            active: '0',
                            Update_By: this.MeData[0].perid,
                          }, this.headerAxios)
                        }
                      }
                      this.Topic = ''
                      this.Cordi_Count = '0'
                      this.Count = '0'
                      this.Date_start = ''
                      this.Date_end = ''
                      this.Date_reg_start = ''
                      this.Date_reg_end = ''
                      this.Time_start = ''
                      this.Time_end = ''
                      this.DepSelect = ''
                      this.Place = ''
                      this.LinkGen = ''
                      this.url = ''
                      this.Place = ''
                      this.Rm = ''
                      this.Register_Cordi = ''
                      this.Ref_id = ''
                      this.JoinMeet = []
                      this.files = []
                      this.FileMeeting = []
                      this.txtAlert = []
                      this.alert = false
                      this.tab = 'DataMeeting'
                      this.staffSel = ''
                      this.init()
                      this.dialogEdit = false
                      this.dialogLoading = false
                      this.$swal.fire({
                        icon: 'success',
                        title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                      })
                    }
                  }
                }
              })
            }
          }
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    OpenReg(item) {
      this.MeetingObj = null
      this.MeetingObj = item
      this.dialogOpenReg = true
    },
    CloseReg(item) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + item.id, {
        Reg_status: '0',
        Update_By: this.MeData[0].perid,
      }, this.headerAxios).then(res => {
        if (res.data.status) {
          this.init()
          this.$swal.fire({
            icon: 'success',
            title: item.Topic + ' ปิดการรับสมัคร!!'
          })
        } else {
          this.init()
          this.$swal.fire({
            icon: 'error',
            title: item.Topic + ' ไม่สามารถปิดการรับสมัครได้ โปรดติดต่อผู้ดูแลระบบ!!'
          })
        }
      })
    },
    SaveOpenReg() {
      if (this.Date_reg_start2 == '' || this.Date_reg_end2 == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุวันที่ลงทะเบียนให้ครบถ้วน'
        })
      } else if (this.Date_reg_start2 > this.Date_reg_end2) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุวันที่ลงทะเบียนให้ถูกต้อง'
        })
      } else {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + this.MeetingObj.id, {
          Reg_status: '1',
          Date_reg_start: this.Date_reg_start2,
          Date_reg_end: this.Date_reg_end2,
          Update_By: this.MeData[0].perid,
        }, this.headerAxios).then(res => {
          if (res.data.status) {
            this.Date_reg_start2 = ''
            this.Date_reg_end2 = ''
            this.dialogOpenReg = false
            this.$swal.fire({
              icon: 'success',
              title: this.MeetingObj.Topic + ' เปิดการรับสมัคร!!'
            })
            this.MeetingObj = null
            this.init()
          } else {
            this.Date_reg_start2 = ''
            this.Date_reg_end2 = ''
            this.dialogOpenReg = false
            this.$swal.fire({
              icon: 'error',
              title: this.MeetingObj.Topic + ' ไม่สามารถเปิดการรับสมัครได้ โปรดติดต่อผู้ดูแลระบบ!!'
            })
            this.MeetingObj = null
            this.init()
          }
        })
      }
    },
    fetchFileMeeting(item) {
      this.dialogFile = true
      this.FileMeetingToDb2 = []
      this.initFileData({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.FileMeetingToDb2 = this.FilesData
        }
      }).catch(resErr => {
        if (resErr) {
          this.FileMeetingToDb2 = []
        }
      })
    },
    OpenDetailMeeting(item) {
      this.dialogShowDetail = true
      this.JoinMeet = []
      this.FileMeetingToDb = []
      this.MeetingObj = null
      this.MeetingObj = item
      this.initJoinMeetingData({
        uuid: item.uuid
      }).then(res => {
        if (res) {
          this.JoinMeet = this.JoinMeetingData
          var checkMatch = false
          this.JoinMeet.map((item, idx) => {
            checkMatch = false
            this.staffData.map(staff => {
              if (staff.perid == item.uid) {
                checkMatch = true
                item.perid = staff.perid
                item.full_Name = staff.full_Name
                item.dep_name = staff.dep_name
                item.dep_group_name = staff.dep_group_name
              }
            })
            if (!checkMatch) {
              item.perid = item.uid
              item.full_Name = item.name + ' ' + item.sname
              item.dep_name = item.position
            }
            item.idx = idx + 1
            item.IsDb = true
          })
        }
      })
      this.initFileData({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.FileMeetingToDb = this.FilesData
        }
      }).catch(resErr => {
        if (resErr) {
          this.FileMeetingToDb = []
        }
      })
    },
    OpenLingMeeting(item) {
      window.open(
          ConstData.PreGenerateLink + item.uuid,
          '_blank' // <- This is what makes it open in a new window.
      );
    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '3' && item.page_status == '1').length > 0) {
              this.maintain = false
              this.initDepartData()
              this.initStaffData().then(res => {
                if (res) {
                  if (this.staffData.length > 0) {
                    this.staffData.map(item => {
                      item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                    })
                  }
                }
              })
              this.init()
            } else {
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>